<template>
  <a-modal
    title="消息提醒"
    :width="800"
    :visible="visible"
    :confirmLoading="confirmLoading"
    @ok="handleOk"
    @cancel="handleCancel"
    cancelText="关闭">

    <a-spin :spinning="confirmLoading">
      <a-form-model ref="form" layout="horizontal" :model="model" v-bind="{labelCol: { span: 4 },wrapperCol: { span: 18 },}" :rules="rules">

        <a-form-model-item  prop="type" label="消息类型" >
          <a-select v-model="model.type" :options="typeList" />
        </a-form-model-item>
        <a-form-model-item prop="content" label="消息内容" >
          <a-textarea placeholder='请填写消息内容' :maxLength='100' v-model="model.content"  />
        </a-form-model-item>
        <a-form-model-item prop="link" label="附带链接" >
          <a-textarea placeholder='非必填'  v-model="model.link"  />
        </a-form-model-item>
        <a-form-model-item prop="groupIdList" label="推送对象" >
          <a-checkbox-group v-model="model.groupIdList" >
            <a-checkbox v-for="(item, index) in groupList" :key="index" :value="item.id">{{ item.name }}</a-checkbox>
          </a-checkbox-group>
        </a-form-model-item>
        <a-form-model-item  prop="pushType" label="推送时间点" >
          <a-radio-group v-model="model.pushType" :options="[{ label: '个性化推送', value: '1' }, { label: '固定日期', value: '2' }]" />
        </a-form-model-item>

        <a-form-model-item  v-if="model.pushType==='2'" prop="pushDate" label="日期" >
          <a-date-picker value-format='YYYY-MM-DD' v-model="model.pushDate"  />
        </a-form-model-item>
        <template v-if="model.pushType==='1'">
          <a-form-model-item  prop="periodItemId" label="周期" >
            <a-select v-model="model.periodItemId" placeholder="请选择" >
              <a-select-option
                v-for="item in periodItemList"
                :key="item.id"
                :value="item.id">
                {{ item.name }}
              </a-select-option>
            </a-select>
          </a-form-model-item>

          <a-form-model-item   label="提前/延后天" help="正数为延后，负数为提前" prop="periodDay" >
            <a-input-number v-model="model.periodDay" placeholder="请输入" :min="-30" :precision="0" style="width: 100%"/>
          </a-form-model-item>

        </template>

      </a-form-model>
    </a-spin>
  </a-modal>
</template>

<script>
  import { getAction,postAction } from '@/api/manage'
  import baseRules from '@/constants/baseRules'
  export default {
    name: 'MessageModel',
    data () {
      return {
        visible: false,
        model: {},
        typeList:[{ label: '测试类型', value: 'test' }],
        confirmLoading: false,
        rules:{
          type:[baseRules.requiredChange],
          content:[baseRules.required],
          groupIdList:[baseRules.requiredChange],
          pushType:[baseRules.requiredChange],
          periodItemId:[baseRules.requiredChange],
          periodDay:[baseRules.required],
          pushDate:[baseRules.requiredChange],
        },
        isView:false,
        groupList:[],
        periodItemList:[],
        url: {
          // add: "/admin/help/add",
          // edit: "/admin/help/edit",
        },

      }
    },
    created () {

    },
    methods: {
      loadData(record){
        if(this.groupList.length===0){
          getAction('/project/projectGroup/list',{projectId:record.projectId}).then(res=>{
            if(res.success){
              this.groupList = res.result
            }
          })
        }
        if(this.periodItemList.length===0){
          getAction('/project/projectPeriodItem/list',{projectId:this.model.projectId,base:'0',halfway:'0'}).then(res=>{
            if(res.success){
              this.periodItemList=res.result
            }
          })
        }
        if(record.groupIds){
          record.groupIdList = record.groupIds.split(',')
        }else{
          record.groupIdList = []
        }
        this.model = Object.assign({}, record);
      },
      view(record){
        this.loadData(record)
        this.isView = true
        this.visible = true;
      },
      edit (record) {
        this.loadData(record)
        this.isView = false
        this.visible = true;
      },
      close () {
        this.visible = false;
        this.$refs.form.clearValidate();
      },
      handleOk () {
        if(this.isView){
          return this.close();
        }
        const that = this;
        this.$refs.form.validate((valid) => {
          // 触发表单验证
          if (valid) {
            const formData = this.model
            let groupIds = ''
            if(formData.groupIdList && formData.groupIdList.length>0){
              formData.groupIdList.forEach(item=>{
                groupIds +=`${item},`
              })
              groupIds = groupIds.substring(0,groupIds.length)
            }
            formData.groupIds = groupIds

            postAction('/project/projectPatientMsg/saveOrUpdate',formData).then((res)=>{
              if(res.success){
                that.$message.success(res.message);
                that.$emit('ok');
                that.close();
              }else{
                that.$message.warning(res.message);
              }
            }).finally(() => {
              that.confirmLoading = false;
            })
          }
        })

      },
      handleCancel () {
        this.close()
      },


      addField(e) {
        this.dataSource.push({})
      },
      removeField(index) {
        this.dataSource.splice(index, 1)
      }


    }
  }
</script>

<style scoped>

</style>
